import React from "react";

import { Navigate } from "react-router-dom";

import { useCaseAnalyticsAccess } from "src/cases/analytics/useCaseAnalyticsAccess";
import { DashboardPageParams, getUrlToCaseQueuePage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
};

// A direct URL to case analytics bypasses the (hidden) nav item, so send
// visitors without access back to the case queues page.
export const CaseAnalyticsRouteGuard: React.FC<Props> = ({ children }) => {
  const { canAccess } = useCaseAnalyticsAccess();
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  if (canAccess) {
    return <>{children}</>;
  }

  return <Navigate replace to={getUrlToCaseQueuePage({ orgId, wsId })} />;
};
